import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../admin/Constant'


export const BannerApi = createApi({
    reducerPath: 'BannerApi',
    baseQuery: fetchBaseQuery({baseUrl:` ${API_URL}/banners`}),
    endpoints: (builder) => ({
        addBanner: builder.mutation({
            query: (data) => ({
             url: `create`,
             method: "POST",
             body: data
            })
         }),
        allBanner: builder.query({
            query: () => ({
                url: "all",
                method: "GET",
            })
         }),
        bannerDetail: builder.query({
            query: (id) => ({
             url: `package-types/${id}`,   // this has no backend routes
             method: "GET",
            })
         }),
        bannerStatus: builder.mutation({
            query: (id) => ({
                url: `status/${id}`,
                method: "PATCH",
            })
         }),
        deleteBanner: builder.mutation({
            query: (id) => ({
            url: `delete/${id}`,
            method: "DELETE",
            })
         }),
         updateBanner: builder.mutation({
            query: (data) => ({
             url: `package-types`,   // this has no backend routes
             method: "PUT",
             body: data
            })
         }),
         }),
})

export const {useAddBannerMutation, useAllBannerQuery, useBannerDetailQuery, useDeleteBannerMutation, useUpdateBannerMutation , useBannerStatusMutation} = BannerApi